/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsUserAlphabet,
    MelcoModelsUserAlphabetFromJSON,
    MelcoModelsUserAlphabetFromJSONTyped,
    MelcoModelsUserAlphabetToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsUserAlphabet
 */
export interface MelcoModelsGenericList1MelcoModelsUserAlphabet {
    /**
     * 
     * @type {Array<MelcoModelsUserAlphabet>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    list: Array<MelcoModelsUserAlphabet>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsUserAlphabetFromJSON(json: any): MelcoModelsGenericList1MelcoModelsUserAlphabet {
    return MelcoModelsGenericList1MelcoModelsUserAlphabetFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsUserAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsUserAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsUserAlphabetFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsUserAlphabetToJSON(value?: MelcoModelsGenericList1MelcoModelsUserAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsUserAlphabetToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


